var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row"},[_c('div',{staticClass:"container-fluid"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h5',[_vm._v("Borrando Cache")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }